import { useState } from 'react';
import { newsletterAPI } from '../../services/api';
import './Newsletter.css';

export default function Newsletter() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (email.trim()) {
      try {
        await newsletterAPI.subscribe(email);
        setSubmitted(true);
        setEmail('');
        setTimeout(() => setSubmitted(false), 3000);
      } catch {
        alert('Subscription failed. Please try again.');
      }
    }
  };

  return (
    <section className="newsletter">
      <div className="container">
        <div className="newsletter__content">
          <h2 className="newsletter__title">Stay Updated</h2>
          <p className="newsletter__description">
            Get the latest product launches, tech updates, and IWX news directly in your inbox.
          </p>
          {submitted ? (
            <p className="newsletter__success">Thank you for subscribing!</p>
          ) : (
            <form className="newsletter__form" onSubmit={handleSubmit}>
              <input
                type="email"
                className="newsletter__input"
                placeholder="Your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                aria-label="Email address"
              />
              <button type="submit" className="btn btn--white">Subscribe</button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}
